/* Purrity cart drawer — behaviour. Port of Prime Organics po-cart-drawer.js v2
   (2026-08-28). Config comes from #prcd-config (emitted by
   sections/pr-cart-drawer.liquid). Subscription upsell converts lines in place via
   /cart/change.js {selling_plan: id | null}; plan ids/discounts are discovered from
   /products/<handle>.js so no plan id is hardcoded. While no product on the store
   carries a selling plan the drawer is a plain one-time cart.

   Theme compat (replaces assets/vy-drawer.js, which is no longer loaded):
     window.VYDrawer.add(items)  POST /cart/add.js {items} then open   (vy-home.js, vy-pdp-simple.js, listicles)
     window.VYDrawer.open/close/pull, .live = true, window.__VY_CART   (sw-tokens' lazy openCart, vy-upsell)
     window.openCart()           sw-pdp.js prefers this global
     [data-vy-cart-open]         pr-header cart button opens the drawer
     [data-vy-cart-count]        pr-header count badge, `hidden` at 0
     vy:currency                 vy-currency.js (Vitals bridge) -> re-render, prices via VY_CC.fmt */
(function(){
  if (window.__PRCD_INIT) return; window.__PRCD_INIT = true;

  var DEF = {
    strip_upsell: 'You can get up to <b>{pct} OFF</b> today <b>with subscription</b>',
    strip_saving: '🎉 <b>Congrats!</b> You\'re saving <b>{pct} OFF</b> on your first subscription',
    tag: 'GET {pct} OFF TODAY',
    primary_sub: 'Save with Subscription',
    primary_co: 'Proceed to Checkout',
    guarantee: '60-Day Money-Back Guarantee',
    secondary: 'Continue with One-Time',
    switch_: 'Switch to one-time purchase ({price})',
    sub_line_sub: 'Delivery {freq}',
    sub_line_one: 'One-time purchase',
    gift_line: 'Free with your subscription',
    elig: 'Subscribe &amp; Save Eligible',
    perks: ['NO CONTRACT|cancel anytime','{pct} OFF|every refill','NEVER RUN OUT|auto-delivery','60-DAY GUARANTEE|money back'],
    trust_label: 'EXCELLENT', trust_rating: '5', trust_text: '', trust_source: '',
    empty_text: 'Your cart is empty', empty_cta: 'Shop the serum', empty_url: '/products/hair-growth-serum',
    fbt_title: 'Frequently bought together:',
    thumbs: {},
    fbt: []
  };
  var CFG = {};
  try { var cn = document.getElementById('prcd-config'); if (cn) CFG = JSON.parse(cn.textContent || '{}') || {}; } catch(e){ CFG = {}; }
  function cfg(k){ var v = CFG[k]; return (v === undefined || v === null || v === '') ? DEF[k] : v; }

  /* ---- sub-only free gifts ----
     Variant ids come from the section settings (#prcd-config "gifts"). The drawer is
     the ONLY writer of gift lines: the buybox adds the main line, every add/change
     re-renders here, and reconcile() makes the cart match the rule
       "a line on a selling plan in cart" <=> "each gift present once, $0, _gift prop".
     Blank ids = feature dormant. A failed gift write disarms reconcile for the page so a
     sold-out/unpublished gift can never loop or block the sale. */
  var GIFTS = (CFG.gifts || []).map(function(x){ return parseInt(x, 10); }).filter(function(x){ return x > 0; });
  /* Welcome Kit (2026-09-22): the gift is earned by a subscription line on
     one of THESE variants only (blank = any subscription line, as before).
     Keeps the free bottle off the old BOGO / 4-bottle plans if anyone still
     reaches them by link, because the admin discount only fires for the
     1-bottle plan and the drawer must not promise "FREE" on a line the
     checkout will charge. */
  var GIFT_FOR = (CFG.gift_for || []).map(function(x){ return parseInt(x, 10); }).filter(function(x){ return x > 0; });
  window.__prGifts = GIFTS.slice();
  var giftsDisarmed = false, reconciling = false;
  /* Two kinds of free line, one look. _gift = the drawer's own digital-gift
     slots (gift_variant_1/2), which reconcile() adds and removes to match the
     GIFTS list exactly. _bonus = the Welcome Kit's bonus bottle, added by
     sw-pdp.js beside the subscription line and made free by the Buy X Get Y
     discount in admin. Both render as FREE and both must go when the
     subscription line goes, but a bonus is never checked against GIFTS —
     doing so is what deleted it. */
  function isGift(it){ return !!(it.properties && (it.properties._gift || it.properties._bonus)); }
  function isBonus(it){ return !!(it.properties && it.properties._bonus); }

  var IC = {
    x:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    chev:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>',
    check:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>',
    star:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z"/></svg>',
    checkc:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.5 2.5L16 9.5"/></svg>'
  };

  var bgEl, drawerEl, plans = {}, planPending = {}, lastCart = null;

  /* vy-currency.js (Vitals bridge) formats in the visitor's currency when it is
     on the page; plain USD otherwise. */
  function money(c){
    try { if (window.VY_CC && typeof window.VY_CC.fmt === 'function'){ var s = window.VY_CC.fmt(c); if (s) return s; } } catch(e){}
    return '$' + (c/100).toFixed(2);
  }
  function pctLabel(p){ return Math.round(p) + '%'; }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function tpl(s, m){ return String(s).replace(/\{(\w+)\}/g, function(_, k){ return m[k] != null ? m[k] : ''; }); }
  function thumb(it){
    if (it.image) return it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x160$1$2');
    var t = cfg('thumbs') || {};
    return t[it.handle] || '';
  }

  function xhr(method, url, data, cb){
    var x = new XMLHttpRequest(), done=false;
    function fin(t){ if(done) return; done=true; cb && cb(t); }
    x.__prcdOwn = true;
    x.open(method, url, true);
    if (data) x.setRequestHeader('Content-Type','application/json');
    x.setRequestHeader('Accept','application/json');
    x.timeout = 8000;
    x.ontimeout = function(){ fin(null); };
    x.onreadystatechange = function(){ if(x.readyState===4) fin(x.responseText); };
    x.send(data ? JSON.stringify(data) : null);
  }

  /* ---- selling plan discovery (per product handle, cached) ---- */
  function planFor(it){
    var p = plans[it.handle];
    if (!p || !p.id) return null;
    var sub = p.byVariant[it.variant_id];
    if (sub == null) return null;
    return { id: p.id, name: p.name, pct: p.pct, subPrice: sub };
  }
  function discover(cart, cb){
    var need = {};
    (cart.items||[]).forEach(function(it){
      /* subscription lines are fetched too: the product JSON is also where the
         per-variant compare-at comes from (fullPriceOf), and a cart holding
         only a subscribed bundle would otherwise never learn the pair is worth
         $98 and would strike the $49 single price instead */
      if (!isGift(it) && it.handle && plans[it.handle] === undefined && !planPending[it.handle]) need[it.handle] = 1;
    });
    var handles = Object.keys(need);
    if (!handles.length){ cb(); return; }
    var left = handles.length;
    handles.forEach(function(h){
      planPending[h] = 1;
      xhr('GET', '/products/' + h + '.js', null, function(t){
        delete planPending[h];
        var rec = { id: null, cmp: {} };
        try {
          var pj = JSON.parse(t);
          /* compare-at per variant, so a one-time line can strike its full value
             ("$98" over the $49 Buy 1 Get 1 Free pair) the way the page does */
          (pj.variants||[]).forEach(function(v){ if (v.compare_at_price > v.price) rec.cmp[v.id] = v.compare_at_price; });
          var g = (pj.selling_plan_groups||[])[0];
          var sp = g && (g.selling_plans||[])[0];
          if (sp){
            var adj = (sp.price_adjustments||[])[0];
            var pct = adj && adj.value_type === 'percentage' ? parseFloat(adj.value) : 0;
            var byVariant = {};
            (pj.variants||[]).forEach(function(v){
              var al = (v.selling_plan_allocations||[]).filter(function(a){ return a.selling_plan_id === sp.id; })[0];
              if (al) byVariant[v.id] = al.price;
              else if (pct) byVariant[v.id] = Math.round(v.price * (100 - pct)) / 100;
              if (!pct && al && v.price) pct = (v.price - al.price) / v.price * 100;
            });
            rec = { id: sp.id, name: sp.name || '', pct: pct, byVariant: byVariant, cmp: rec.cmp };
          }
        } catch(e){}
        plans[h] = rec;
        if (--left === 0) cb();
      });
    });
  }

  /* ---- DOM ---- */
  function ensureDrawer(){
    if (drawerEl) return;
    bgEl = document.createElement('div'); bgEl.className='prcd__bg';
    drawerEl = document.createElement('div'); drawerEl.className='prcd'; drawerEl.setAttribute('role','dialog'); drawerEl.setAttribute('aria-modal','true'); drawerEl.setAttribute('aria-label','Cart'); drawerEl.setAttribute('tabindex','-1');
    drawerEl.innerHTML =
      '<div class="prcd__head"><span class="prcd__title">Your Cart</span><span class="prcd__count">0</span><button class="prcd__x" type="button" aria-label="Close">'+IC.x+'</button></div>'+
      '<div class="prcd__strip" hidden></div>'+
      '<div class="prcd__body" data-body></div>'+
      '<div data-fbt></div>'+
      '<div class="prcd__foot" data-foot></div>'+
      '<div class="prcd__spin"></div>';
    document.body.appendChild(bgEl); document.body.appendChild(drawerEl);
    bgEl.addEventListener('click', closeCart);
    drawerEl.querySelector('.prcd__x').addEventListener('click', closeCart);
    document.documentElement.setAttribute('data-prcd-on','');
    drawerEl.addEventListener('click', onAction);
    // keyboard: Escape closes, Tab stays inside the dialog while it is open
    document.addEventListener('keydown', function(e){
      if (!drawerEl.classList.contains('open')) return;
      if (e.key === 'Escape' || e.keyCode === 27){ e.preventDefault(); closeCart(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(drawerEl.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'), function(el){ return el.offsetWidth || el.offsetHeight; });
      if (!f.length) return;
      var first = f[0], last = f[f.length-1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === drawerEl)){ e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    });
  }
  var lastFocus = null;

  var accHolder = null;
  function accNode(){
    if (!accHolder){
      var src = document.getElementById('prcd-acc-src');
      accHolder = document.createElement('div'); accHolder.className = 'prcd__accwrap';
      if (src){ while (src.firstChild) accHolder.appendChild(src.firstChild); src.parentNode && src.parentNode.removeChild(src); }
    }
    return accHolder;
  }
  function mountAcc(){
    var slot = drawerEl.querySelector('[data-acc]');
    if (!slot) return;
    slot.appendChild(accNode());
    try { if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) Shopify.PaymentButton.init(); } catch(e){}
  }

  /* the old vy-drawer is no longer loaded, but if a stale copy ever is, keep it shut */
  function killOld(){
    document.querySelectorAll('.vyd, #vyd, cart-drawer, #CartDrawer').forEach(function(d){ d.classList.remove('is-open','active','animate','open'); });
    document.querySelectorAll('.vyd-scrim').forEach(function(d){ d.classList.remove('is-open'); });
    ['vyd-lock','overflow-hidden'].forEach(function(c){ document.body.classList.remove(c); document.documentElement.classList.remove(c); });
  }
  function openDrawer(){ ensureDrawer(); killOld(); document.body.style.overflow='hidden'; bgEl.classList.add('open');
    if (!drawerEl.classList.contains('open')) lastFocus = document.activeElement;
    /* rAF is paused in background tabs, which would leave the drawer parked
       off-screen with its contents rendered; a timer runs whichever wins */
    var armed = false, arm = function(){ if (armed) return; armed = true; drawerEl.classList.add('open'); };
    requestAnimationFrame(arm); setTimeout(arm, 40);
    setTimeout(function(){ killOld(); var x = drawerEl.querySelector('.prcd__x'); if (x && drawerEl.classList.contains('open') && !drawerEl.contains(document.activeElement)) x.focus({ preventScroll: true }); }, 120);
    setTimeout(killOld, 450); }
  function closeCart(){ if(!drawerEl || !drawerEl.classList.contains('open')) return; drawerEl.classList.remove('open'); bgEl.classList.remove('open'); document.body.style.overflow=''; killOld();
    var lf = lastFocus; lastFocus = null; if (lf && lf.focus && document.contains(lf)) { try { lf.focus({ preventScroll: true }); } catch(e){} } }

  /* ---- render ---- */
  function analyse(cart){
    var items = cart.items || [], eligible = [], subs = [], others = [], gifts = [];
    var maxPct = 0, subTotalIfAll = 0, oneTimeTotal = 0, saving = 0, subPct = 0, fullTotal = 0, paidCount = 0;
    items.forEach(function(it){
      var spa = it.selling_plan_allocation;
      if (isGift(it)){
        gifts.push(it);
        /* A free line is still worth something and the shopper is still getting
           it. The Welcome Kit's bonus bottle is a $0 variant with a $49
           compare-at, so counting its value here is what lets the drawer read
           "$98.00 -> $29.95" — the number the PDP promises — instead of $49,
           and lets the count say 2 bottles instead of 1. Its final_line_price
           is 0, so it adds nothing to what she actually pays. */
        fullTotal += it.original_line_price || it.final_line_price || 0;
        paidCount += unitsOf(it) * it.quantity;
        return;
      }
      /* fullTotal is the sum of exactly what each row strikes (rowHTML's `cap`),
         so the footer's struck subtotal can never disagree with the rows above
         it — a Buy 1 Get 1 row striking $98 used to sit over a $49 subtotal,
         because both spa.compare_at_price and cart.original_total_price only
         know the bundle's own price, not what the pair is worth. */
      fullTotal += lineFullPrice(it);
      paidCount += unitsOf(it) * it.quantity;
      if (spa){
        subs.push(it);
        subTotalIfAll += it.final_line_price;
        var cap = spa.compare_at_price || 0;
        oneTimeTotal += cap > spa.price ? cap * it.quantity : it.final_line_price;
        /* saving/subPct stay on the plan's own basis: they advertise the
           subscription discount, not the bundle's value */
        if (cap > spa.price){ saving += (cap - spa.price) * it.quantity; var pp = (cap - spa.price) / cap * 100; if (pp > subPct) subPct = pp; }
      } else {
        var pl = planFor(it);
        if (pl){ eligible.push(it); subTotalIfAll += pl.subPrice * it.quantity; if (pl.pct > maxPct) maxPct = pl.pct; }
        else { others.push(it); subTotalIfAll += it.final_line_price; }
        oneTimeTotal += it.final_line_price;
      }
    });
    /* paidCount is counted in bottles, not cart lines, so the badge, the
       "Subtotal: n items" label and the per-row steppers all say the same
       number (a Buy 1 Get 1 line is one line but two bottles). Free gift
       bottles count too: she receives them. */
    return { items:items, eligible:eligible, subs:subs, others:others, gifts:gifts, paidCount:paidCount, maxPct:maxPct, subPct:subPct, subTotalIfAll:subTotalIfAll, oneTimeTotal:oneTimeTotal, fullTotal:fullTotal, saving:saving };
  }

  function imgHTML(it){
    var img = thumb(it);
    return img ? '<img class="prcd__ci-img" src="'+esc(img)+'" alt="" loading="lazy">' : '<div class="prcd__ci-img"></div>';
  }
  function giftRowHTML(it){
    return '<div class="prcd__ci is-gift" data-key="'+esc(it.key)+'">'+imgHTML(it)+
      '<div class="prcd__ci-main"><p class="prcd__ci-name">'+esc(it.product_title)+'</p>'+
      '<p class="prcd__ci-sub">'+esc(cfg('gift_line'))+'</p>'+
      '<div class="prcd__ci-pricerow">'+(it.original_line_price > 0 ? wasHTML(it.original_line_price) : '')+'<span class="prcd__ci-price is-free">FREE</span></div>'+
      '</div><div class="prcd__ci-side"><span class="prcd__ci-gifttag">'+IC.check+'GIFT</span></div></div>';
  }
  /* Simple drawer (2026-09-07): header, lines, subtotal, one checkout button.
     The Javvy-style upsell furniture (tint strip, GET X% OFF tag, "Save with
     Subscription", "Continue with One-Time", switch link, perks grid, trust
     line, frequently-bought rail, eligibility tags, OFF pills) is all gated
     behind SIMPLE === false. Strike-through prices stay: they are the truth
     about what the line costs, not an upsell. */
  var SIMPLE = cfg('simple') !== false;

  /* A bundle is one cart line but several bottles, so the stepper read "1" for
     a two-bottle pair. The count comes from the SKU tail (PUR-BRD-60 -> 60
     servings, 30 servings = one bottle), which is the rule the PDP already
     uses: snippets/sw-buybox-kit.liquid and sections/sw-buybox.liquid derive
     their per-serving price the same way, both commented "so the variant title
     is free to carry the offer". Reading the title here instead would make it
     load-bearing and let an admin rename silently change the count. */
  var SERVINGS_PER_UNIT = 30;
  function unitsOf(it){
    var tail = parseInt(String(it.sku || '').split('-').pop(), 10);
    if (!(tail > 0)) return 1;
    return Math.max(1, Math.floor(tail / SERVINGS_PER_UNIT));
  }
  /* the variant's own compare-at ($98 over the $49 pair), discovered per handle */
  function fullPriceOf(it){
    var pc = plans[it.handle];
    return (pc && pc.cmp && pc.cmp[it.variant_id]) || 0;
  }
  /* drop a trailing count parenthetical — "(2 Bottles)", "(4 Tubes)" — once the
     stepper is showing that number. Any unit noun, since the drawer is shared. */
  var COUNT_SUFFIX = /\s*\([^)]*\d[^)]*\)\s*$/;
  function offerOf(it){
    var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
    return vt.replace(COUNT_SUFFIX, '').trim();
  }
  function wasHTML(cents){ return '<span class="prcd__ci-was">'+money(cents)+'</span>'; }
  /* What one line is worth before every discount on it, in cents — the single
     basis for the row's strike-through AND the footer's struck subtotal, so the
     two can never disagree. 0 when there is nothing honest to strike. */
  function lineCap(it){
    var spa = it.selling_plan_allocation, full = fullPriceOf(it);
    if (spa){
      var unit = Math.max(spa.compare_at_price || 0, full);
      return unit > spa.price ? unit * it.quantity : 0;
    }
    if (it.original_line_price > it.final_line_price) return it.original_line_price;
    return full > it.price ? full * it.quantity : 0;
  }
  function lineFullPrice(it){ return lineCap(it) || it.final_line_price; }

  function rowHTML(it){
    if (isGift(it)) return giftRowHTML(it);
    var spa = it.selling_plan_allocation;
    var units = unitsOf(it), shown = units * it.quantity;
    var offer = offerOf(it);
    var sub, elig = '', off = '';
    if (spa){
      /* plan names read "Deliver every 2 months, 20% off"; strip the verb so
         the template's own "Delivers" does not double it up */
      var freq = (spa.selling_plan && spa.selling_plan.name || '').replace(/^deliver(y|s|ed)?\s+/i,'').toLowerCase();
      sub = tpl(cfg('sub_line_sub'), { freq: esc(freq || 'recurring') });
      if (offer) sub = esc(offer) + ' · ' + sub;
      if (!SIMPLE){
        var unit = Math.max(spa.compare_at_price || 0, fullPriceOf(it));
        if (unit > spa.price) off = '<span class="prcd__ci-off">'+money((unit - spa.price) * it.quantity)+' off</span>';
      }
    } else {
      /* variant title carries the offer on this store ("Buy 1 Get 1 Free", "30 Servings") */
      sub = offer ? esc(offer) : cfg('sub_line_one');
      if (!SIMPLE && planFor(it)) elig = '<span class="prcd__ci-elig">'+IC.check+'<span>'+cfg('elig')+'</span></span>';
    }
    /* the struck price always reads before the price it is struck against */
    var cap = lineCap(it), was = cap ? wasHTML(cap) : '';
    /* one bundle is indivisible, so "−" on the last one would delete the line
       while the stepper is showing 2; Remove, right below, is the honest path */
    var decOff = units > 1 && it.quantity <= 1;
    var step = units > 1 ? ' '+units+' at a time' : '';
    return '<div class="prcd__ci" data-key="'+esc(it.key)+'">'+imgHTML(it)+
      '<div class="prcd__ci-main"><p class="prcd__ci-name">'+esc(it.product_title)+'</p>'+
      '<p class="prcd__ci-sub">'+sub+'</p>'+
      '<div class="prcd__ci-pricerow">'+was+'<span class="prcd__ci-price">'+money(it.final_line_price)+'</span>'+off+'</div>'+
      elig+'</div>'+
      '<div class="prcd__ci-side"><span class="prcd__qty" data-qty="'+it.quantity+'"><button type="button" data-dec aria-label="Decrease'+step+'"'+(decOff ? ' disabled' : '')+'>&minus;</button><span>'+shown+'</span><button type="button" data-inc aria-label="Increase'+step+'">+</button></span>'+
      '<button class="prcd__ci-del" type="button" data-del>Remove</button></div></div>';
  }

  function fbtHTML(cart){
    var list = cfg('fbt') || [];
    var inCart = {};
    (cart.items||[]).forEach(function(it){ inCart[it.variant_id] = 1; });
    var cards = list.filter(function(p){ return p && p.variant_id && p.available !== false && p.price > 0 && !inCart[p.variant_id]; });
    if (!cards.length) return '';
    var html = '<div class="prcd__fbt"><p class="prcd__fbt-title">'+esc(cfg('fbt_title'))+'</p><div class="prcd__fbt-rail">';
    var t = cfg('thumbs') || {};
    cards.forEach(function(p){
      var img = p.image || t[p.handle] || '';
      html += '<div class="prcd__fbt-card">'+
        (img?'<img class="prcd__fbt-img" src="'+esc(img)+'" alt="" loading="lazy">':'<div class="prcd__fbt-img"></div>')+
        '<div class="prcd__fbt-main"><p class="prcd__fbt-name">'+esc(p.title)+'</p><p class="prcd__fbt-sub">'+esc(p.sub || 'One-time add-on')+'</p><p class="prcd__fbt-price">'+money(p.price)+'</p></div>'+
        '<button class="prcd__fbt-add" type="button" data-fbt-add="'+esc(p.variant_id)+'">Add +</button></div>';
    });
    html += '</div>';
    if (cards.length > 1){ html += '<div class="prcd__fbt-dots">'; cards.forEach(function(_, i){ html += '<i'+(i?'':' class="on"')+'></i>'; }); html += '</div>'; }
    return html + '</div>';
  }

  function perksHTML(pct){
    var perks = cfg('perks') || [];
    var h = '<div class="prcd__perks">';
    perks.forEach(function(p){
      if (!p) return;
      var parts = String(p).split('|');
      var b = tpl(parts[0], {pct: pct}), r = tpl(parts.slice(1).join('|'), {pct: pct});
      h += '<span class="prcd__perk">'+IC.check+'<span><b>'+esc(b)+'</b>'+(r?' '+esc(r):'')+'</span></span>';
    });
    return h + '</div>';
  }
  function trustHTML(){
    if (!cfg('trust_text')) return '';
    var rating = parseFloat(cfg('trust_rating')) || 5, stars = '';
    for (var i=0;i<5;i++) stars += '<span class="'+(i < Math.round(rating) ? 'on' : '')+'">'+IC.star+'</span>';
    var src = cfg('trust_source') ? ' <b class="prcd__src">'+esc(cfg('trust_source'))+'</b>' : '';
    return '<div class="prcd__trust"><b>"'+esc(cfg('trust_label'))+'"</b><span class="prcd__stars">'+stars+'</span><span>'+esc(cfg('trust_text'))+src+'</span></div>';
  }
  function btn(tag, cls, extra, label, price){
    return '<'+tag+' class="'+cls+'" '+extra+'><span class="lbl">'+label+'</span><span class="prc">'+money(price)+'</span>'+IC.chev+'</'+tag+'>';
  }

  function footHTML(cart, a){
    if (!a.items.length) return '';
    var total = cart.total_price;
    /* the rows' own strike-through basis, summed — not cart.original_total_price,
       which like spa.compare_at_price knows only the bundle's price and would
       print $49 under a row striking $98. oneTimeTotal stays the switch link's
       number: that one really is "what you'd pay without the subscription". */
    var orig = a.fullTotal;
    var n = a.paidCount;
    var h = '<div class="prcd__totrow"><span class="prcd__totlbl">Subtotal: '+n+' '+(n === 1 ? 'item' : 'items')+'</span><span class="prcd__totright">';
    if (orig > total){ h += '<span class="prcd__was">'+money(orig)+'</span>'; }
    h += '<span class="prcd__tot">'+money(total)+'</span>';
    if (!SIMPLE && orig > total){ h += '<span class="prcd__off">'+money(orig-total)+' OFF</span>'; }
    h += '</span></div>';
    var pct = pctLabel(a.maxPct);
    if (SIMPLE){
      h += '<a class="prcd__primary is-center is-plain" href="/checkout"><span class="lbl">'+cfg('primary_co')+'</span>'+IC.chev+'</a>';
      if (cfg('guarantee')) h += '<div class="prcd__guarantee"><span>'+IC.checkc+esc(cfg('guarantee'))+'</span></div>';
      h += '<div class="prcd__acc" data-acc></div>';
      return h;
    }
    if (a.eligible.length){
      h += '<div class="prcd__tagwrap"><span class="prcd__tag">'+tpl(cfg('tag'), {pct: pct})+'</span></div>';
      h += btn('button', 'prcd__primary', 'type="button" data-sub-all', cfg('primary_sub'), a.subTotalIfAll);
      h += perksHTML(pct);
      h += btn('a', 'prcd__secondary', 'href="/checkout"', cfg('secondary'), total);
    } else if (a.subs.length){
      h += '<a class="prcd__primary is-center" href="/checkout"><span class="lbl">'+cfg('primary_co')+'</span>'+IC.chev+'</a>';
      h += '<div class="prcd__guarantee"><span>'+IC.checkc+esc(cfg('guarantee'))+'</span></div>';
      h += '<button class="prcd__switch" type="button" data-one-all>'+tpl(cfg('switch_'), {price: money(a.oneTimeTotal)})+'</button>';
    } else {
      h += '<a class="prcd__primary is-center is-plain" href="/checkout"><span class="lbl">'+cfg('primary_co')+'</span>'+IC.chev+'</a>';
      h += '<div class="prcd__guarantee"><span>'+IC.checkc+esc(cfg('guarantee'))+'</span></div>';
    }
    h += '<div class="prcd__acc" data-acc></div>' + trustHTML();
    return h;
  }
  function emptyHTML(){
    var url = cfg('empty_url'), cta = cfg('empty_cta');
    return '<div class="prcd__empty"><p>'+esc(cfg('empty_text'))+'</p>'+(url && cta ? '<a class="prcd__empty-cta" href="'+esc(url)+'">'+esc(cta)+IC.chev+'</a>' : '')+'</div>';
  }

  function syncHeader(n){
    document.querySelectorAll('[data-vy-cart-count]').forEach(function(el){
      el.textContent = n;
      if (n) el.removeAttribute('hidden'); else el.setAttribute('hidden','');
    });
    var a = document.getElementById('cart-icon-bubble'); if (!a) return;
    var b = a.querySelector('.cart-count-bubble');
    if (!n){ if (b) b.parentNode.removeChild(b); return; }
    if (!b){ b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); }
    b.innerHTML = (n < 100 ? '<span aria-hidden="true">'+n+'</span>' : '') + '<span class="visually-hidden">'+n+' '+(n === 1 ? 'item' : 'items')+'</span>';
  }
  function renderCart(cart){
    ensureDrawer();
    lastCart = cart;
    window.__VY_CART = cart.items || [];
    var a = analyse(cart);
    drawerEl.querySelector('.prcd__count').textContent = a.paidCount;
    syncHeader(a.paidCount);
    var strip = drawerEl.querySelector('.prcd__strip');
    if (SIMPLE){ strip.hidden = true; }
    else if (a.eligible.length){ strip.innerHTML = tpl(cfg('strip_upsell'), {pct: pctLabel(a.maxPct)}); strip.hidden = false; }
    else if (a.subs.length && a.saving > 0){ strip.innerHTML = tpl(cfg('strip_saving'), {amt: money(a.saving), pct: pctLabel(a.subPct)}); strip.hidden = false; }
    else strip.hidden = true;
    var body = drawerEl.querySelector('[data-body]');
    var ordered = a.items.filter(function(it){ return !isGift(it); }).concat(a.gifts);
    body.innerHTML = a.items.length ? ordered.map(rowHTML).join('') : emptyHTML();
    drawerEl.querySelector('[data-fbt]').innerHTML = a.items.length && !SIMPLE ? fbtHTML(cart) : '';
    drawerEl.querySelector('[data-foot]').innerHTML = footHTML(cart, a);
    if (a.items.length) mountAcc();
    var rail = drawerEl.querySelector('.prcd__fbt-rail');
    if (rail) rail.addEventListener('scroll', function(){ var i = Math.round(rail.scrollLeft / (rail.firstElementChild.offsetWidth + 12)); drawerEl.querySelectorAll('.prcd__fbt-dots i').forEach(function(d, j){ d.classList.toggle('on', j===i); }); }, {passive:true});
  }

  function giftPlan(a){
    var qualifies = a.subs.some(function(it){ return !GIFT_FOR.length || GIFT_FOR.indexOf(it.variant_id) >= 0; });
    var want = qualifies && GIFTS.length ? GIFTS : [];
    var adds = [], removes = [], fixes = [];
    var have = {};
    a.gifts.forEach(function(it){
      /* the kit's bonus bottle has no slot on the GIFTS list. It stays as long
         as a qualifying subscription line is in the cart — the Buy X Get Y
         discount only fires against that line, so a bonus left behind alone
         would be charged full price for a row the drawer prints as FREE. */
      if (isBonus(it)){ if (!qualifies) removes.push(it); return; }
      var slot = parseInt(it.properties._gift, 10);
      var ok = want.length && slot >= 1 && slot <= want.length && want[slot-1] === it.variant_id && !have[slot];
      if (!ok){ removes.push(it); return; }
      have[slot] = it;
      if (it.quantity !== 1) fixes.push(it);
    });
    want.forEach(function(id, i){ if (!have[i+1]) adds.push({ id: id, quantity: 1, properties: { _gift: String(i+1) } }); });
    return { adds: adds, removes: removes, fixes: fixes };
  }
  function reconcile(cart, cb){
    var a = analyse(cart), plan = giftPlan(a);
    if (giftsDisarmed || reconciling || (!plan.adds.length && !plan.removes.length && !plan.fixes.length)){ cb(false); return; }
    reconciling = true;
    var steps = [];
    plan.removes.forEach(function(it){ steps.push(function(next){ changeLine(it.key, 0, undefined, function(t){ next(!!t); }); }); });
    plan.fixes.forEach(function(it){ steps.push(function(next){ changeLine(it.key, 1, undefined, function(t){ next(!!t); }); }); });
    if (plan.adds.length) steps.push(function(next){ xhr('POST','/cart/add.js', { items: plan.adds }, function(t){ var ok = false; try { ok = !!(JSON.parse(t).items); } catch(e){} next(ok); }); });
    (function run(i){
      if (i >= steps.length){ reconciling = false; cb(true); return; }
      steps[i](function(ok){ if (!ok){ giftsDisarmed = true; reconciling = false; cb(true); return; } run(i+1); });
    })(0);
  }
  function render(cart, cb){
    discover(cart, function(){
      renderCart(cart);
      reconcile(cart, function(changed){
        if (!changed){ cb && cb(); return; }
        xhr('GET','/cart.js',null,function(t){ var c=null; try{ c = JSON.parse(t); }catch(e){} if (c && c.items) renderCart(c); cb && cb(); });
      });
    });
  }

  /* ---- actions ---- */
  function busy(on){ if (!drawerEl) return; drawerEl.classList.toggle('loading', !!on); }
  var wd;
  function guard(){ clearTimeout(wd); busy(true); wd = setTimeout(function(){ busy(false); }, 9000); }
  function finish(t){ clearTimeout(wd); var done = function(){ busy(false); document.dispatchEvent(new CustomEvent('prcd:changed')); };
    try { var c = JSON.parse(t); if (c && c.items) render(c, done); else refresh(done); } catch(e){ refresh(done); } }

  function changeLine(key, q, plan, cb){
    var body = { id: key, quantity: q };
    if (plan !== undefined) body.selling_plan = plan;
    xhr('POST','/cart/change.js', body, cb);
  }
  function changeQty(key, q){ guard(); changeLine(key, q, undefined, finish); }

  // convert lines one at a time: each change rewrites that line's key, others stay valid
  function convertAll(list, planOf){
    guard();
    var i = 0, last = null;
    (function next(){
      if (i >= list.length){ finish(last); return; }
      var it = list[i++];
      changeLine(it.key, it.quantity, planOf(it), function(t){ last = t; next(); });
    })();
  }
  function fbtAdd(vid){
    guard();
    xhr('POST','/cart/add.js', { items:[{ id: Number(vid), quantity: 1 }] }, function(){ clearTimeout(wd); refresh(function(){ busy(false); document.dispatchEvent(new CustomEvent('prcd:changed')); }); });
  }

  function onAction(e){
    var t = e.target.closest ? e.target : null; if (!t) return;
    var row = t.closest('.prcd__ci'), key = row && row.getAttribute('data-key');
    if (t.closest('[data-inc]') && key){ changeQty(key, qtyOf(row)+1); return; }
    if (t.closest('[data-dec]') && key){ changeQty(key, qtyOf(row)-1); return; }
    if (t.closest('[data-del]') && key){ changeQty(key, 0); return; }
    if (t.closest('[data-sub-all]') && lastCart){ var a = analyse(lastCart); convertAll(a.eligible, function(it){ return planFor(it).id; }); return; }
    if (t.closest('[data-one-all]') && lastCart){ var b = analyse(lastCart); convertAll(b.subs, function(){ return null; }); return; }
    var add = t.closest('[data-fbt-add]'); if (add){ fbtAdd(add.getAttribute('data-fbt-add')); return; }
    if (t.closest('.prcd__empty-cta')){ closeCart(); return; }
  }
  /* the stepper renders bottles, not cart lines, so the real line quantity
     rides on data-qty and +/- still move by one bundle at a time */
  function qtyOf(row){
    var q = row.querySelector('.prcd__qty');
    return q ? (parseInt(q.getAttribute('data-qty'), 10) || 0) : 0;
  }

  var refreshQ = null;
  function refresh(cb){
    if (refreshQ){ refreshQ.push(cb); return; }
    refreshQ = [cb];
    xhr('GET','/cart.js',null,function(t){
      var q = refreshQ; refreshQ = null;
      var fire = function(){ q.forEach(function(f){ f && f(); }); };
      var c=null; try{ c = JSON.parse(t); }catch(e){}
      if (c && c.items) render(c, fire); else fire();
    });
  }
  function refreshP(){ return new Promise(function(res){ refresh(res); }); }

  function showCart(){ ensureDrawer(); openDrawer(); guard();
    refresh(function(){ clearTimeout(wd); busy(false); }); }

  /* ---- public API + vy-drawer.js compat ---- */
  function addItems(items){
    var list = Array.isArray(items) ? items : [items];
    list = list.filter(Boolean).map(function(it){
      var o = { id: Number(it.id), quantity: Number(it.quantity) || 1 };
      if (it.selling_plan) o.selling_plan = it.selling_plan;
      if (it.properties) o.properties = it.properties;
      return o;
    });
    if (!list.length) return Promise.resolve(null);
    ensureDrawer(); guard();
    return new Promise(function(res, rej){
      xhr('POST','/cart/add.js', { items: list }, function(t){
        var j = null; try { j = JSON.parse(t); } catch(e){}
        if (!j || !j.items){ clearTimeout(wd); busy(false); rej(new Error(j && (j.description || j.message) || 'Could not add to cart')); return; }
        showCart(); res(j);
      });
    });
  }
  window.openCart = showCart;
  window.__prCartDrawer = { open: showCart, close: closeCart, refresh: refresh };
  window.VYDrawer = { add: addItems, open: showCart, close: closeCart, render: function(){ if (lastCart) renderCart(lastCart); }, pull: refreshP, live: true };

  /* ---- hook every add flow so the drawer opens ---- */
  function hookAdd(){
    if (window.fetch && !window.fetch.__prcd){
      var of = window.fetch.bind(window);
      var wrapped = function(){
        var a0 = arguments[0];
        var url = (a0 && typeof a0 === 'object' && a0.url) ? a0.url : a0;
        var p = of.apply(null, arguments);
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)){
          p.then(function(){ setTimeout(showCart, 30); }).catch(function(){});
        }
        return p;
      };
      wrapped.__prcd = true;
      window.fetch = wrapped;
    }
    var ox = XMLHttpRequest.prototype.open;
    if (!ox.__prcd){
      XMLHttpRequest.prototype.open = function(m,u){ this.__prcdUrl=u; return ox.apply(this, arguments); };
      XMLHttpRequest.prototype.open.__prcd = true;
      var os = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function(){
        var self=this;
        if (!self.__prcdOwn && typeof self.__prcdUrl==='string' && /\/cart\/(add)/.test(self.__prcdUrl)){
          self.addEventListener('load', function(){ setTimeout(showCart, 30); });
        }
        return os.apply(this, arguments);
      };
    }
  }

  function bind(){
    ensureDrawer();
    hookAdd();
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('[data-vy-cart-open], #cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"]');
      if (a){ e.preventDefault(); showCart(); }
    }, true);
    document.addEventListener('vy:currency', function(){ if (lastCart) renderCart(lastCart); });
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
